import { http, httpFile } from './http_service';


export function all(){
    return http().get('/user');
}
export function list(){
    return http().get('/user/list');
}
export function listPage(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        dealerId: obj.dealerId,
        role_id:obj.role_id,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/user/list-page`, {
        params:params
    });
}



export function single(id){
    return http().get(`/user/single/${id}`);
}
export function add(data){
    return http().post('/user', data)
}
export function update(id, data){
    return http().post(`/user/${id}`, data)
}
export function deleteSingle(id){
    return http().delete(`/user/${id}`);
}

//Get Dropdown list
export function dropdownList(){
    return http().get(`/user/dropdown-list`);
}

/**
 *
 * @returns Array
 */
export function dropdownListBasedFullName(){
    return http().get(`/user/dropdown-list-based-full-name`);
}
